import type { Degree } from '@/models/template';

/** Severity-degree colors for finding-statement pills. The color is the pill's
 *  border; unselected pills show a faint tint of it, selected pills fill solid. */
export const DEGREE_COLORS: Record<Degree, string> = {
  NORMAL: '#A8D08D', // green
  MILD: '#FFE599', // yellow
  MODERATE: '#F4B183', // orange
  SEVERE: '#E06666', // red
  NEUTRAL: '#D9D9D9', // gray
};

/** Resolve a leaf's degree to its color, falling back to NEUTRAL when absent. */
export const degreeColor = (degree?: Degree): string =>
  DEGREE_COLORS[degree ?? 'NEUTRAL'];
